var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",on:{"click":function($event){return _vm.$router.push({name: 'home'})}}},[_c('a',{attrs:{"href":"javascript:void(0);"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }